export default __webpack_public_path__ + "static/media/yellow-2.c2215802.png";